import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PerAnnotatorStats } from '../labeling-task-overview.component';

@Component({
    selector: 'image-classification-per-labeler-stats',
    templateUrl: './image-classification-per-labeler-stats.component.html',
    styleUrls: ['../shared-overview.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageClassificationPerLabelerStatsComponent {

    @Input() perAnnotatorStats: PerAnnotatorStats;
}
